export default {
  title: "Challenges",
  sections: {
    challenges_hero_section: {
      fields: {
        field_one: {
          value: {
            text: '<div class="highlight">Heraus forderungen</div> für Ingenieur-Unternehmen',
            text2: 'SEU bietet Lösungen für aktuelle <br/> und zukünftige Herausforderungen <br/> und eine Chance für innovative Köpfe',
            image: '/seu/latest-assets/seu_23.jpg'
          }
        },
      }
    },
    challenges_divider_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Challenges'
          }
        }
      }
    },
    challenges_cover_section: {
      fields: {
        field_one: {
          value: {
            image: '/seu/latest-assets/seu_31.jpg'          }
        }
      }
    },
    challenges_text_section: {
      fields: {
        field_one: {
          value: {
            text: '<span class="text-highlight">Challenges</span> der Schweizer Engineering-Branche',
            text2: 'Die Herausforderungen unserer Branche sind bekannt – eine Besserung zeichnet sich nicht ab. Im Gegenteil: Die perfekte Konstellation für eine geeignete Nachfolge ist schwer zu finden. Vielen Firmen fehlt es an Fachkräften oder Kapital. Und manchmal auch an beidem.'
          }
        },
        field_three: {
          value: {
            text: 'Das operative Geschäft kämpft mit zunehmendem Kostendruck und sinkenden Margen, mit einem harten Wettbewerb zwischen internationalen Konzernen und KMU. Hinzu kommen die Herausforderungen der fortschreitenden Digitalisierung.',
            text2: 'Oft tragen wenige Schultern eine grosse Verantwortung. Denn so komplex die Herausforderungen, so flexibel müssen Mitarbeitende und Management heute sein.  In diesem Kontext ist auch der Generationenwechsel eine zentrale Herausforderung.',
            text3: 'Vielseitigkeit, agiles und verantwortungsvolles Handeln sowie eine robuste Unternehmenskultur tragen dazu bei, kräftezehrende Belastungen oder akute Krisen zu meistern.'
          }
        },
      }
    },
    challenges_divider2_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Welche Steine liegen Ihrem Unternehmen im Weg?'
          }
        }
      }
    },
    challenges_features_section: {
      fields: {
        field_one: {
          value: {
            boxes: [
              {
                name: 'Fachkräftemangel',
                image: '/seu/latest-assets/seu_01.jpg',
                subTitle: 'Der Fachkräftemarkt in der Schweiz gleicht einer Wüste. Investieren Sie wertvolle Arbeitszeit und viel Budget, um Ihren Durst nach Fachkräften zu stillen? Stehen Sie im Wettbewerb mit grösseren Unternehmen, um Ihre Attraktivität mit Zusatzleistungen mühsam zu erhöhen?\n' +
                  '<p>Kennen wir. <a href="/angebot#succession" class="text-highlight" > Lassen Sie uns das gemeinsam lösen</a>. </p>',
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                name: 'Nachfolgelösungen',
                image: '/seu/latest-assets/seu_02.jpg',
                subTitle: `Kompetenz, Verantwortungsbewusstsein, persönliches Engagement, Freude am Unternehmertum sowie hinreichend finanzielle Mittel finden nicht immer zeitgleich zusammen. Haben Sie schon den perfekten Match, um Ihren Driver Seat professionell zu besetzen? Stehen für Ihre Nachfolge Familienmitglieder bereit – oder haben sich diese für ein anderes Lebenskonzept entschieden? Sind Sie mit Investoren im Gespräch – aber kommen nicht recht vom Fleck?
                  <p> Sicher ist: Sie wollen Ihr Lebenswerk in guten Händen wissen. <a href="/angebot#economic_security" class="text-highlight" >Gemeinsam machen wir es möglich<a/>.</p> `,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                name: 'Wettbewerb',
                image: '/seu/latest-assets/seu_03.jpg',
                subTitle: `Tradition und Erfolg stehen auf Ihrer Seite. Doch im weiten Ozean des Wettbewerbs reicht das manchmal nicht mehr aus. Grosse Fische erbeuten grosse Aufträge. Einzelaufträge verschwimmen mit Gesamtdienstleistungen, die Kleinunternehmer kaum mehr leisten können. Aber auch viele kleine und mittlere Mitbewerber liefern sich einen erbitterten Preiskampf auf Kosten der Rentabilität. Die Marge wird dünn. Doch die Schwarmintelligenz bringt Sie <a href="/angebot#processes" class="text-highlight" >wieder auf Kurs</a>.</p>`,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                name: 'Digitalisierung',
                image: '/seu/latest-assets/seu_04.jpg',
                subTitle: `Klar: Ohne robuste IT läuft nichts. Doch es geht um mehr. Investieren Sie gezielt – und vor allem schon genug, um talentierte Mitarbeitende im Bereich BIM für die Pole Position zu befähigen? Ist Ihr Unternehmen in Sachen Cyber Security auf dem neuesten Stand und damit sicher vor Hackern und IT-Erpressern? Und wie steht es um die Technologiekenntnisse Ihres Teams?
<p>Viele Fragen auf vielen Ebenen. Lassen Sie uns gemeinsam die <a href="/angebot#digitalization" class="text-highlight" >Antworten finden<a/>. </p>`,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                name: 'Kostendruck',
                image: '/seu/latest-assets/seu_05.jpg',
                subTitle: `Grösser, höher, weiter – der Engineering-Markt ist hart umkämpft. Die Preise für Ihre Dienstleistungen steigen dabei leider nicht automatisch mit der Qualität Ihrer Leistungen. Im Gegenteil: Zunehmend werden die Marktpreise von globalen Konzernen und grossen Unternehmen diktiert. Die Abwärtsspirale von hohem Kostendruck und fehlendem Investment trifft auch gesunde KMU und bringt sie wirtschaftlich ins Schwanken. Garantieren Ihre Margen noch Sicherheit auf lange Sicht?
<p> Erfolg braucht Investition. Sorgen Sie rechtzeitig für <a href="/angebot#management_support" class="text-highlight" >finanziellen Spielraum<a/>. </p> `,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },
              {
                name: 'Finanzierung',
                image: '/seu/latest-assets/seu_06.jpg',
                subTitle: `Je kleiner das Ingenieurunternehmen, desto schwieriger ist es, seriöse Finanzierungsquellen auszuschöpfen. Hand aufs Herz: Haben Sie schon einmal darüber nachgedacht, in die Familienkasse zu greifen, um Investitionen tätigen zu können? Oder ringen Sie mit ambitionierten Wachstumsplänen, um wettbewerbsfähig zu bleiben?
<p> Finanzierung ist Vertrauenssache. <a href="/angebot#management_support" class="text-highlight" > Erzählen Sie uns von Ihrer Vision<a/>.</p>`,
                buttonLabel: 'Mehr',
                buttonLabelLess: 'Weniger',
              },

            ]
          }
        }
      }
    },
    challenges_divider3_section: {
      fields: {
        field_one: {
          value: {
            divider: 'Challenges'
          }
        }
      }
    },
    challenges_text_2_section: {
      fields: {
        field_one: {
          value: {
            text: 'Swiss Engineers United bietet eine Branchenlösung'
          }
        },
        field_two: {
          value: {
            text: 'Wir sind überzeugt: Kundennähe, ein nachhaltiges Wachstum und markenstarke Performance sind auch unter schwierigen Bedingungen möglich.'
          }
        },
        field_three: {
          value: {
            text: 'Als Schweizer Unternehmer mit jahrzehntelanger Expertise in den Bereichen Hoch- und Tiefbau, Geomatik und Ingenieurwesen kennen wir die Herausforderungen der Branche so gut wie ein Ingenieur seine Mess-, Berechnungs- und Konstruktionswerkzeuge. Wir wissen, worauf es ankommt und wie wir die Probleme gemeinsam anpacken können.',
            text2: 'SEU öffnet Türen – für neuen Schwung, neue Wege, neue Partnerschaften, neue Kooperationen und neues Wachstum. Als eines der ersten Unternehmen der SEU baute beispielsweise die <a class="text-highlight" href="/strategie#best-practises">HMQ AG</a> eine internationale Offshore-Produktionsstätte für die Schweiz auf.',
            text3: 'Wenn der Druck stetig grösser wird und Ihre Ziele in die Ferne rücken, anstatt näher zu kommen – dann braucht es starke Partnerschaften auf Augenhöhe.'
          }
        },
      }
    },
    challenges_call_to_action_section: {
      fields: {
        field_one: {
          value: {
            text: 'Wir begleiten Sie.',
            text2: 'Mit der Power unserer Gruppendynamik.',
            buttonLabel: 'Gemeinsam handeln',
            buttonIcon: '/seu/arrow-right.svg',
            buttonLink: '/kontakt',
            image: '/seu/latest-assets/seu_35.jpg',
          }
        },
      }
    }
  }
}
